/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  GetDmConversationResponse,
  GetDmConversationsResponse,
  GetDmMessagesResponse,
  GetDmUnreadCountResponse,
  MarkDmReadResponse,
  SendDmMessageBody,
  SendDmMessageResponse,
  UpdateDmSettingsBody,
  UpdateDmSettingsResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    GetDmConversationResponseFromJSON,
    GetDmConversationResponseToJSON,
    GetDmConversationsResponseFromJSON,
    GetDmConversationsResponseToJSON,
    GetDmMessagesResponseFromJSON,
    GetDmMessagesResponseToJSON,
    GetDmUnreadCountResponseFromJSON,
    GetDmUnreadCountResponseToJSON,
    MarkDmReadResponseFromJSON,
    MarkDmReadResponseToJSON,
    SendDmMessageBodyFromJSON,
    SendDmMessageBodyToJSON,
    SendDmMessageResponseFromJSON,
    SendDmMessageResponseToJSON,
    UpdateDmSettingsBodyFromJSON,
    UpdateDmSettingsBodyToJSON,
    UpdateDmSettingsResponseFromJSON,
    UpdateDmSettingsResponseToJSON,
} from '../models/index';

export interface CreateDmConversationsUserIdMessagesRequest {
    userId: string;
    sendDmMessageBody: SendDmMessageBody;
}

export interface GetDmConversationsRequest {
    limit?: number;
    offset?: number;
    includeArchived?: boolean;
}

export interface GetDmConversationsUserIdRequest {
    userId: string;
}

export interface GetDmConversationsUserIdMessagesRequest {
    userId: string;
    before?: number;
    limit?: number;
}

export interface UpdateDmConversationsUserIdReadRequest {
    userId: string;
    body?: object;
}

export interface UpdateDmConversationsUserIdSettingsRequest {
    userId: string;
    updateDmSettingsBody: UpdateDmSettingsBody;
}

/**
 * DirectMessagesApi - interface
 * 
 * @export
 * @interface DirectMessagesApiInterface
 */
export interface DirectMessagesApiInterface {
    /**
     * Send a DM to the specified user
     * @summary Send a direct message
     * @param {string} userId Recipient user ID
     * @param {SendDmMessageBody} sendDmMessageBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectMessagesApiInterface
     */
    createDmConversationsUserIdMessagesRaw(requestParameters: CreateDmConversationsUserIdMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendDmMessageResponse>>;

    /**
     * Send a DM to the specified user
     * Send a direct message
     */
    createDmConversationsUserIdMessages(requestParameters: CreateDmConversationsUserIdMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendDmMessageResponse>;

    /**
     * Returns list of DM conversations sorted by most recent activity
     * @summary Get user\'s DM conversations
     * @param {number} [limit] Max conversations to return
     * @param {number} [offset] Offset for pagination
     * @param {boolean} [includeArchived] Include archived conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectMessagesApiInterface
     */
    getDmConversationsRaw(requestParameters: GetDmConversationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDmConversationsResponse>>;

    /**
     * Returns list of DM conversations sorted by most recent activity
     * Get user\'s DM conversations
     */
    getDmConversations(requestParameters: GetDmConversationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDmConversationsResponse>;

    /**
     * Returns the DM conversation with the specified user, creating it if needed
     * @summary Get or create conversation with user
     * @param {string} userId The other user\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectMessagesApiInterface
     */
    getDmConversationsUserIdRaw(requestParameters: GetDmConversationsUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDmConversationResponse>>;

    /**
     * Returns the DM conversation with the specified user, creating it if needed
     * Get or create conversation with user
     */
    getDmConversationsUserId(requestParameters: GetDmConversationsUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDmConversationResponse>;

    /**
     * Returns paginated messages for the conversation with specified user
     * @summary Get messages in a DM conversation
     * @param {string} userId The other user\&#39;s ID
     * @param {number} [before] Get messages before this timestamp (for pagination)
     * @param {number} [limit] Max messages to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectMessagesApiInterface
     */
    getDmConversationsUserIdMessagesRaw(requestParameters: GetDmConversationsUserIdMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDmMessagesResponse>>;

    /**
     * Returns paginated messages for the conversation with specified user
     * Get messages in a DM conversation
     */
    getDmConversationsUserIdMessages(requestParameters: GetDmConversationsUserIdMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDmMessagesResponse>;

    /**
     * Returns the total number of unread direct messages across all conversations
     * @summary Get total unread DM count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectMessagesApiInterface
     */
    getDmUnreadCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDmUnreadCountResponse>>;

    /**
     * Returns the total number of unread direct messages across all conversations
     * Get total unread DM count
     */
    getDmUnreadCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDmUnreadCountResponse>;

    /**
     * Marks all unread messages in the conversation as read
     * @summary Mark conversation as read
     * @param {string} userId The other user\&#39;s ID
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectMessagesApiInterface
     */
    updateDmConversationsUserIdReadRaw(requestParameters: UpdateDmConversationsUserIdReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkDmReadResponse>>;

    /**
     * Marks all unread messages in the conversation as read
     * Mark conversation as read
     */
    updateDmConversationsUserIdRead(requestParameters: UpdateDmConversationsUserIdReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkDmReadResponse>;

    /**
     * Update mute, archive, or block status for a DM conversation
     * @summary Update conversation settings
     * @param {string} userId The other user\&#39;s ID
     * @param {UpdateDmSettingsBody} updateDmSettingsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectMessagesApiInterface
     */
    updateDmConversationsUserIdSettingsRaw(requestParameters: UpdateDmConversationsUserIdSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateDmSettingsResponse>>;

    /**
     * Update mute, archive, or block status for a DM conversation
     * Update conversation settings
     */
    updateDmConversationsUserIdSettings(requestParameters: UpdateDmConversationsUserIdSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateDmSettingsResponse>;

}

/**
 * 
 */
export class DirectMessagesApi extends runtime.BaseAPI implements DirectMessagesApiInterface {

    /**
     * Send a DM to the specified user
     * Send a direct message
     */
    async createDmConversationsUserIdMessagesRaw(requestParameters: CreateDmConversationsUserIdMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendDmMessageResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling createDmConversationsUserIdMessages().'
            );
        }

        if (requestParameters['sendDmMessageBody'] == null) {
            throw new runtime.RequiredError(
                'sendDmMessageBody',
                'Required parameter "sendDmMessageBody" was null or undefined when calling createDmConversationsUserIdMessages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dm/conversations/{userId}/messages`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendDmMessageBodyToJSON(requestParameters['sendDmMessageBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendDmMessageResponseFromJSON(jsonValue));
    }

    /**
     * Send a DM to the specified user
     * Send a direct message
     */
    async createDmConversationsUserIdMessages(requestParameters: CreateDmConversationsUserIdMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendDmMessageResponse> {
        const response = await this.createDmConversationsUserIdMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns list of DM conversations sorted by most recent activity
     * Get user\'s DM conversations
     */
    async getDmConversationsRaw(requestParameters: GetDmConversationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDmConversationsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['includeArchived'] != null) {
            queryParameters['includeArchived'] = requestParameters['includeArchived'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dm/conversations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDmConversationsResponseFromJSON(jsonValue));
    }

    /**
     * Returns list of DM conversations sorted by most recent activity
     * Get user\'s DM conversations
     */
    async getDmConversations(requestParameters: GetDmConversationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDmConversationsResponse> {
        const response = await this.getDmConversationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the DM conversation with the specified user, creating it if needed
     * Get or create conversation with user
     */
    async getDmConversationsUserIdRaw(requestParameters: GetDmConversationsUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDmConversationResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getDmConversationsUserId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dm/conversations/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDmConversationResponseFromJSON(jsonValue));
    }

    /**
     * Returns the DM conversation with the specified user, creating it if needed
     * Get or create conversation with user
     */
    async getDmConversationsUserId(requestParameters: GetDmConversationsUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDmConversationResponse> {
        const response = await this.getDmConversationsUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns paginated messages for the conversation with specified user
     * Get messages in a DM conversation
     */
    async getDmConversationsUserIdMessagesRaw(requestParameters: GetDmConversationsUserIdMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDmMessagesResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getDmConversationsUserIdMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dm/conversations/{userId}/messages`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDmMessagesResponseFromJSON(jsonValue));
    }

    /**
     * Returns paginated messages for the conversation with specified user
     * Get messages in a DM conversation
     */
    async getDmConversationsUserIdMessages(requestParameters: GetDmConversationsUserIdMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDmMessagesResponse> {
        const response = await this.getDmConversationsUserIdMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the total number of unread direct messages across all conversations
     * Get total unread DM count
     */
    async getDmUnreadCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDmUnreadCountResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dm/unread-count`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDmUnreadCountResponseFromJSON(jsonValue));
    }

    /**
     * Returns the total number of unread direct messages across all conversations
     * Get total unread DM count
     */
    async getDmUnreadCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDmUnreadCountResponse> {
        const response = await this.getDmUnreadCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Marks all unread messages in the conversation as read
     * Mark conversation as read
     */
    async updateDmConversationsUserIdReadRaw(requestParameters: UpdateDmConversationsUserIdReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkDmReadResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateDmConversationsUserIdRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dm/conversations/{userId}/read`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkDmReadResponseFromJSON(jsonValue));
    }

    /**
     * Marks all unread messages in the conversation as read
     * Mark conversation as read
     */
    async updateDmConversationsUserIdRead(requestParameters: UpdateDmConversationsUserIdReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkDmReadResponse> {
        const response = await this.updateDmConversationsUserIdReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update mute, archive, or block status for a DM conversation
     * Update conversation settings
     */
    async updateDmConversationsUserIdSettingsRaw(requestParameters: UpdateDmConversationsUserIdSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateDmSettingsResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateDmConversationsUserIdSettings().'
            );
        }

        if (requestParameters['updateDmSettingsBody'] == null) {
            throw new runtime.RequiredError(
                'updateDmSettingsBody',
                'Required parameter "updateDmSettingsBody" was null or undefined when calling updateDmConversationsUserIdSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dm/conversations/{userId}/settings`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDmSettingsBodyToJSON(requestParameters['updateDmSettingsBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateDmSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Update mute, archive, or block status for a DM conversation
     * Update conversation settings
     */
    async updateDmConversationsUserIdSettings(requestParameters: UpdateDmConversationsUserIdSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateDmSettingsResponse> {
        const response = await this.updateDmConversationsUserIdSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
